// paynow.tsx
import React, { useEffect, useRef, useState } from "react";
import style from "./payNow.module.css";
import axios from "axios";
import CryptoJS from "crypto-js";
import dustbin from "../../../assets/images/btn/dustbin.svg";
import plusIcon from "../../../assets/images/btn/plus.svg";
import Modal from "react-bootstrap/Modal";
import { MDBCard, MDBCardBody, MDBContainer } from "mdb-react-ui-kit";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { ErrorToast, SuccessToast } from "../../../components/toastMessage";
import { useLocation, useNavigate } from "react-router-dom";
import { BASE_URL, validPaymentStatuses, validRepaymentStatuses } from "../../../constants/Constants";
import uploadImage from '../../../utils/azure-storage-blob';
import PayOnline from "./PayOnline";
import { useSetUser, useUser } from "../../../contexts/UserContext";
import { useSetStuffToRenderOnNavbar } from "../../../contexts/NavbarCommonSpace"
import ResubmissionHeader from "./ResubmissionHeader";
import { DeleteButton } from "../../../components/CommonComponents/EditComponent/EditComponent";
import { _axios } from "../../../utils/axios";

interface Receipt {
  // receipt_no: number;
  receipt_id?: number;
  receipt_no: string;
  amount_paid: number;
  payment_date: string;
  payment_status: string;
  receipt_file: string;
  file_url: string;
}

interface DemandDetails {
  id: number;
  municipality: string;
  tehsil: string;
  plot_no: string;
  district: string;
  due_date: Date;
  applicant_name: string;
  layout_name: string;
  area: number;
  mauja: string;
  khasaraNo: string;
  construction_area: number;
  particular1Rate: number;
  particular1Total: number;
  particular2Rate: number;
  particular2Total: number;
  scrutinyCharges: number;
  totalAmount: number;
  conditions: string;
  review_id: number;
  application_id: number;
  tenant_id: string;
}


function payNow() {
  const [lgShow, setLgShow] = useState(false);
  const [PaymentLgShow, setPaymentLgShow] = useState(false);
  const [receiptSections, setReceiptSections] = useState(1);
  const [receiptNo, setReceiptName] = useState<string[]>([""]);
  const [paymentDate, setPaymentDate] = useState<string[]>([""]);
  const [amountPaid, setAmountPaid] = useState<number[]>([0]);
  const [recordExists, setRecordExists] = useState(false);
  const [accountNo, setAccountNo] = useState("");
  const [ifsCode, setIfsCode] = useState(0);
  const [accountType, setAccountType] = useState("");
  const [branch, setBranch] = useState("");
  const [bank, setBank] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const [receipts, setReceipts] = useState<Receipt[]>([]);
  const [selectedReceipt, setSelectedReceipt] = useState<Receipt | null>(null);
  const { user, paymentStatus, id } = location.state;
  const [showButton, setShowButton] = useState(false);
  const [existenceData, setExistenceData] = useState({ exists: false });
  const inputRef = useRef<HTMLInputElement>(null);
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const [totalAmount, setTotalAmount] = useState<number | null>(null);
  const [totalAmountPaid, setTotalAmountPaid] = useState(0);
  const [demandDetails, setDemandDetails] = useState<DemandDetails | any>();
  const [baseAmount, setBaseAmount] = useState<number | null>(null);
  const [interestAccumulated, setInterestAccumulated] = useState<number | null>(null);
  const [daysPending, setDaysPending] = useState<number>(0);
  const [demandDetailsList, setDemandDetailsList] = useState<any[]>([]);
  const [activeDocTab, setActiveDocTab] = useState<"signed" | "revised">("signed");
  const [receiptFile, setReceiptFile] = useState<File[]>([]);
  const [receiptFileUrls, setReceiptFileUrls] = useState<string[]>([]);
  const [pdfUrl, setPdfUrl] = useState("");
  const userObj = useUser();
  const setUser = useSetUser();
  const [isReceiptEdit, setIsReceiptEdit] = useState<boolean>(false);
  const [currentEditRecipt, setCurrentEditRecipt] = useState<number>(-1);
  const isArchitectOrUser = ["user", "architect"].includes(
    userObj?.role?.toLowerCase() || ""
  );
  const isAdmin = userObj?.role?.toLowerCase()?.includes("admin");
  const selectedReceiptIndex = receipts.findIndex((r) => r === selectedReceipt);
  const file = receiptFile[selectedReceiptIndex];
  const [isSaving, setIsSaving] = useState(false);
  const saveButtonRef = useRef<HTMLButtonElement>(null);
  interface BankDetailsState {
    account_holder_name: string;
    account_no: string;
    ifs_code: string;
    bank_name: string;
    branch_name: string;
    account_type?: string;
  }

  const [bankDetails, setBankDetails] = useState<BankDetailsState>({
    account_holder_name: "",
    account_no: "",
    ifs_code: "",
    bank_name: "",
    branch_name: "",
    account_type: "",
  });


  const decryptData = (data: {
    account_holder_name: string | CryptoJS.lib.CipherParams;
    account_no: string | CryptoJS.lib.CipherParams;
    ifs_code: string | CryptoJS.lib.CipherParams;
    bank_name: string | CryptoJS.lib.CipherParams;
    branch_name: string | CryptoJS.lib.CipherParams;
    account_type?: string;
  }) => {
    const decryptedData = { ...data };

    if (typeof data.account_holder_name !== "string") {
      decryptedData.account_holder_name = CryptoJS.AES.decrypt(
        data.account_holder_name,
        "encryptionKey"
      ).toString(CryptoJS.enc.Utf8);
    }

    decryptedData.account_holder_name = CryptoJS.AES.decrypt(
      data.account_holder_name,
      "encryptionKey"
    ).toString(CryptoJS.enc.Utf8);
    decryptedData.account_no = CryptoJS.AES.decrypt(
      data.account_no,
      "encryptionKey"
    ).toString(CryptoJS.enc.Utf8);
    decryptedData.ifs_code = CryptoJS.AES.decrypt(
      data.ifs_code,
      "encryptionKey"
    ).toString(CryptoJS.enc.Utf8);
    decryptedData.bank_name = CryptoJS.AES.decrypt(
      data.bank_name,
      "encryptionKey"
    ).toString(CryptoJS.enc.Utf8);
    decryptedData.branch_name = CryptoJS.AES.decrypt(
      data.branch_name,
      "encryptionKey"
    ).toString(CryptoJS.enc.Utf8);

    // Provide a default value for account_type if it's missing
    if (!decryptedData.account_type) {
      decryptedData.account_type = ""; // Set it to an empty string
    }

    return {
      ...decryptedData,
      account_holder_name: String(decryptedData.account_holder_name),
      account_no: String(decryptedData.account_no),
      ifs_code: String(decryptedData.ifs_code),
      bank_name: String(decryptedData.bank_name),
      branch_name: String(decryptedData.branch_name),
    };
  };

  const fetchBankDetails = async () => {
    try {
      const existenceResponse = await _axios.get(
        `${BASE_URL}/api/bankDetails/checkExistence`
      );
      setExistenceData(existenceResponse.data.exists);

      if (existenceResponse.data.exists) {
        const bankDetailsResponse = await _axios.get(
          `${BASE_URL}/api/bankDetails/getBankDetails`
        );
        const decryptedBankDetails = decryptData(
          bankDetailsResponse.data.result
        );

        setBankDetails(decryptedBankDetails);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchBankDetails();
  }, [existenceData]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const payOffline = await _axios.get(
          `${BASE_URL}/api/uploadReceipt/getPayOffline`
        );
        const ReciptData = payOffline.data.result;

        setAccountNo(ReciptData[0].account_no);
        setIfsCode(ReciptData[0].ifs_code);
        setAccountType(ReciptData[0].account_type);
        setBranch(ReciptData[0].branch_name);
        setBank(ReciptData[0].bank_name);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [recordExists]);

  const handleHoverIn = () => {
    setIsHovered(true);
  };

  const handleHoverOut = () => {
    setIsHovered(false);
  };

  const handleReceiptClick = (receipt: Receipt, index: number) => {
    setSelectedReceipt(receipt);
    setIsReceiptEdit(true);
    setCurrentEditRecipt(index);
  };

  const handleReceiptClose = () => {
    setSelectedReceipt(null);
  };

  const handleAddSection = () => {
    setReceiptSections((prevSections) => prevSections + 1);
  };

  const handleRemoveSection = (index: number) => {
    if (receiptSections > 1) {
      setReceiptSections((prevSections) => prevSections - 1);
      setReceiptName((prev) => prev.filter((_, i) => i !== index));
      setAmountPaid((prev) => prev.filter((_, i) => i !== index));
      setPaymentDate((prev) => prev.filter((_, i) => i !== index));
      setReceiptFile((prev) => prev.filter((_, i) => i !== index));
    }
  };

  useEffect(() => {
    console.log("Payment status for this page: ", user.status);
    if (
      user.status === 'Pending Payment' ||
      user.status === 'Returned For Repayment By Level 2 Reviewer' ||
      user.status === 'Returned For Repayment By Level 3 Reviewer'
    ) {
      setShowButton(true);
    }
  }, [user.status]);

  const setStuff = useSetStuffToRenderOnNavbar();

  useEffect(() => {
    if (user) {
      setStuff(
        <div className="md:ml-auto md:mr-8">
          <p className="text-grey-600">
            <span className="w-28 font-semibold inline-block">
              Application ID
            </span>
            <span className="text-grey-600 font-semibold mx-2">:</span>
            <span>{user.application_id || "Nil"}</span>
          </p>
          <p className="text-grey-600 flex items-center">
            <span className="w-28 text-grey-600 font-semibold inline-block">
              Status
            </span>
            <span className="text-grey-600 font-semibold mx-2">:</span>
            <span className="text-primary">
              {user.status || "Nil"}
            </span>
          </p>
        </div>
      );
    } else {
      setStuff(null);
    }

    return () => setStuff(null);
  }, [setStuff, user]);

  const calculateTotalAmount = (receipts: any[]) => {
    let totalAckPayment = 0;
    receipts.forEach((receipt) => {
      if (receipt.payment_status === 'Payment Successful' || receipt.payment_status === 'Payment Acknowledgment') {
        totalAckPayment += parseFloat(receipt.amount_paid);
      }
    });
    return totalAckPayment;
  };


  useEffect(() => {
    const total = calculateTotalAmount(receipts);
    setTotalAmountPaid(total);
  }, [receipts]);

  const demandId = user.id;
  const applicationId = user.application_id;
  const applicationStatus = user?.status;

  const [revisedPdfUrlState, setRevisedPdfUrlState] = useState<string | null>(null);

  useEffect(() => {
    const getDemandNote = async () => {
      try {
        const response = await _axios.post(`${BASE_URL}/api/digital-signature-docs/list`, { submitted_by: "Level 3", application_id: applicationId });
        const list = response?.data?.data || [];

        const signedDoc = list.find((d: any) => d.doc_type === "demand note" || d.doc_type === "demand_note") || list[0];

        const filteredList = [];
        if (signedDoc) filteredList.push(signedDoc);

        if (revisedPdfUrlState) {
          filteredList.push({
            doc_type: "revised demand note",
            file_url: revisedPdfUrlState,
            created_at: new Date().toISOString(),
          });
        }

        setDemandDetailsList(filteredList);
        setDemandDetails(filteredList[0] || null);
        console.log("Filtered Demand note list: ", filteredList);
      } catch (error) {
        console.error("Error fetching Demand Note details:", error);
        ErrorToast("Failed to fetch Demand Note details");
      }
    };

    getDemandNote();
  }, [applicationId, revisedPdfUrlState]);


  const validateFields = () => {
    for (let i = 0; i < receiptSections; i++) {
      if (!receiptNo[i] || !amountPaid[i] || !paymentDate[i] || !receiptFile[i]
      ) {
        return false;
      }
    } return true;
  };

  const fetchReceiptsData = async () => {
    try {
      const existenceResponse = await _axios.get(
        `${BASE_URL}/api/uploadReceipt/checkExistence?application_id=${user.application_id}`
      );
      if (existenceResponse.data.exists) {
        // Records exist, fetch receipts
        const receiptsResponse = await _axios.get(
          `${BASE_URL}/api/uploadReceipt/getReceipts?application_id=${user.application_id}`
        );
        console.log(receiptsResponse.data.result);
        setReceipts(receiptsResponse.data.result);
      } else {

        console.log("No existing records for this user.");
        setRecordExists(false);
      }
    } catch (error) {
      console.error("Error fetching receipts:", error);
    }
  };

  useEffect(() => {

    fetchReceiptsData();

  }, []);

  // const id = user.id;

  const getTotalAmount = (id: any) => {
    const apiUrl = `${BASE_URL}/api/uploadReceipt/getTotalAmount`;

    _axios.post(apiUrl, { application_id: id })
      .then(response => {
        console.log('totatlamt', response.data);
        const { totalAmount, baseAmount, interestAccumulated, daysPending, revisedPdfUrl } = response.data;
        setTotalAmount(totalAmount);
        setBaseAmount(baseAmount);
        setInterestAccumulated(interestAccumulated);
        setDaysPending(daysPending || 0);
        setRevisedPdfUrlState(revisedPdfUrl || null);
      })
      .catch(error => {
        console.error("Error fetching total amount:", error);
      });
  };

  useEffect(() => {
    getTotalAmount(id);
  }, [id]);





  const handlePublish = async (isSubmit: boolean) => {
    try {
      const existingReceiptsResponse = await _axios.get(
        `${BASE_URL}/api/uploadReceipt/getReceipts?application_id=${user.application_id}`
      );
      const existingReceipts = existingReceiptsResponse.data.result;

      // Update existing records' payment status
      const updatedReceiptsPromises = existingReceipts.map(
        async (receipt: { payment_status: string; }) => {
          if (receipt.payment_status === "Draft" || receipt.payment_status === "Payment Discrepancy") {
            // Update the payment status to "Submitted" if isSubmit is true
            if (isSubmit) {
              console.log("Submitted hit");
              await _axios.post(
                `${BASE_URL}/api/uploadReceipt/update`,
                {
                  ...receipt,
                  payment_status: "Submitted",
                }
              );
            }
          }
          return receipt;
        }
      );

      await Promise.all(updatedReceiptsPromises);

      if (isSubmit) {
        await handleSubmitPaymentStatus();
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleSubmitPaymentStatus = async () => {
    try {
      console.log("Changes status to pending payment level 2 review at:");
      // Update the payment status
      await _axios.post(
        `${BASE_URL}/api/uploadReceipt/updatePaymentStatus`,
        {
          application_id: applicationId,
          status: applicationStatus === 'Returned for Returned For Repayment By Level 3 Reviewer' ? "Pending Payment Level 3 Review" : "Pending Payment Level 2 Review",
        }
      )
        .then(() => {
          // After updating the payment status, send the application payment status email
          _axios.post(
            `${BASE_URL}/api/uploadReceipt/send`,
            {
              body: {
                email: userObj?.email,
                name: userObj?.name
              },
              application_id: applicationId
            }
          )
            .then((response) => {
              console.log("Email sent successfully:", response.data);
              SuccessToast("Your application has been sent for level 2 and level 3 payment review.");
            })
            .catch((error) => {
              console.error("Error sending email:", error);
            });
        })
        .catch((error) => {
          console.error("Error updating payment status:", error);
        });
    } catch (error) {
      console.error("Error updating payment status or sending email:", error);
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const payOffline = await _axios.get(
          `${BASE_URL}/api/uploadReceipt/getPayOffline`
        );
        const ReciptData = payOffline.data.result;

        setAccountNo(ReciptData[0].account_no);
        setIfsCode(ReciptData[0].ifs_code);
        setAccountType(ReciptData[0].account_type);
        setBranch(ReciptData[0].branch_name);
        setBank(ReciptData[0].bank_name);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [recordExists]);



  const showPayNowButton =
    validPaymentStatuses.includes(applicationStatus) &&
    ((applicationStatus === 'Pending Payment' && !receipts?.length) || (validRepaymentStatuses.includes(applicationStatus)))

  const handleCreateRecord = async () => {
    setIsSaving(true);
    if (!validateFields()) {
      ErrorToast("All fields are required. Please fill in all the fields.");
      setIsSaving(false);
      return;
    }
    const saveButton = saveButtonRef.current;
    //const saveButton = document.querySelector(`.${style.saveButton}`) as HTMLButtonElement | null;
    if (saveButton && saveButton.disabled) {
      return;
    }

    try {
      // Create FormData for file upload
      const formData = new FormData();

      // Prepare receipts data
      const receiptDataArray = [];
      for (let i = 0; i < receiptSections; i++) {
        receiptDataArray.push({
          receipt_no: receiptNo[i],
          amount_paid: amountPaid[i],
          payment_date: paymentDate[i],
          application_id: applicationId,
          payment_status: "Draft",
        });

        // Append files to FormData
        if (receiptFile[i]) {
          formData.append('receipt_files', receiptFile[i]);
        }
      }

      // Append receipts data as JSON
      formData.append('receipts', JSON.stringify(receiptDataArray));

      try {
        const apiUrl = `${BASE_URL}/api/uploadReceipt/create`;
        const response = await _axios.post(apiUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          params: { paymentStatus: "Draft" },
        });

        console.log(response.data);
        console.log('Response sent to DB:', response.data);
        SuccessToast("Records created successfully.");
        fetchReceiptsData();

      } catch (error) {
        console.error("Error creating new receipts:", error);
        ErrorToast("Failed to create receipts. Please try again.");
      }

    } catch (error) {
      console.error("Error:", error);
      ErrorToast("An error occurred. Please try again.");
    } finally {
      if (saveButton) {
        saveButton.disabled = true;
        setTimeout(() => {
          saveButton.disabled = false;
          setIsSaving(false);
        }, 3000);
      } else {
        setIsSaving(false);
      }

      // Reset form
      setReceiptName([]);
      setAmountPaid([]);
      setPaymentDate([]);
      setReceiptFile([]);
    }
  };

  const handleReceiptChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
    field: string
  ) => {
    const { value, files } = e.target;

    if (field === "receipt_file" && files && files.length > 0) {
      const file = files[0];

      // Just update the display name - actual upload happens in handleEditReceipt
      setReceipts((prevReceipts) => {
        const updatedReceipts = [...prevReceipts];
        updatedReceipts[index] = {
          ...updatedReceipts[index],
          [field]: file.name, // Store filename for display
        };
        setSelectedReceipt(updatedReceipts[index]);
        return updatedReceipts;
      });
    } else {
      setReceipts((prevReceipts) => {
        const updatedReceipts = [...prevReceipts];
        updatedReceipts[index] = {
          ...updatedReceipts[index],
          [field]: value,
        };
        setSelectedReceipt(updatedReceipts[index]);
        return updatedReceipts;
      });
    }
  };

  const handleSave = () => {
    if (currentEditRecipt != -1 && isReceiptEdit) {
      handleEditReceipt();
    }
    if (receiptSections === 1) {
      if (receiptNo[0] || amountPaid[0] || paymentDate[0] || receiptFile[0]
      ) {
        handleCreateRecord();
      }
    }
    else {
      handleCreateRecord();
    }

    //  handleCreateRecord();

  };


  const handleEditReceipt = async () => {
    try {
      if (currentEditRecipt === -1 || !selectedReceipt) return;

      const formData = new FormData();

      // Add receipt data
      formData.append('receipt_id', selectedReceipt.receipt_id?.toString() || '');
      formData.append('receipt_no', selectedReceipt.receipt_no);
      formData.append('amount_paid', selectedReceipt.amount_paid.toString());
      formData.append('payment_date', selectedReceipt.payment_date);
      formData.append('payment_status', selectedReceipt.payment_status);
      formData.append('application_id', applicationId);

      // Check if there's a new file to upload
      const fileInput = document.querySelectorAll(`input[type="file"]`)[currentEditRecipt] as HTMLInputElement;
      const file = fileInput?.files?.[0];

      if (file) {
        formData.append('receipt_file', file);
      } else {
        // Keep existing file URL - this will be handled by backend
        formData.append('existing_file_url', selectedReceipt.receipt_file);
      }

      const response = await _axios.post(`${BASE_URL}/api/uploadReceipt/update`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log("Updated receipt response:", response.data);
      SuccessToast("Receipt updated successfully.");

      // Refresh receipts data
      fetchReceiptsData();
      setSelectedReceipt(null);
      setIsReceiptEdit(false);
      setCurrentEditRecipt(-1);

    } catch (error) {
      console.error("Error updating receipt:", error);
      ErrorToast("Failed to update receipt. Please try again later.");
    }
  };

  const getDownloadName = (docType: string) => {
    const appIdClean = user?.application_id || 'demand_note';
    if (docType === "demand note" || docType === "demand_note") {
      return `${appIdClean}_Original_Demand_Note.pdf`;
    }

    // Calculate month number
    const monthNumber = Math.ceil((daysPending - 60) / 30);
    const monthStr = monthNumber > 0 ? `Month_${monthNumber}` : 'Revised';
    return `${appIdClean}_${monthStr}_Revised_Demand_Note.pdf`;
  };

  const downloadFile = async (url: string, filename: string) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error(`Error downloading ${filename}:`, error);
      ErrorToast(`Failed to download ${filename}`);
    }
  };

  const handleDownloadPDF = async () => {
    try {
      if (demandDetailsList && demandDetailsList.length > 0) {
        for (const doc of demandDetailsList) {
          if (doc.file_url) {
            const downloadName = getDownloadName(doc.doc_type);
            await downloadFile(doc.file_url, downloadName);
          }
        }
      } else if (demandDetails?.file_url) {
        const downloadName = getDownloadName(demandDetails.doc_type);
        await downloadFile(demandDetails.file_url, downloadName);
      } else {
        ErrorToast('PDF download failed. URL is not available.');
      }
    } catch (error) {
      console.error('Error downloading PDF:', error);
      ErrorToast('PDF download failed. Please try again later.');
    }
  };

  return (
    <div>
      <div className={style.bodyHeading}>
        <div className={style.logoUploadContainer}>
          <div className={style.pdfFrame}>
            <ResubmissionHeader applicationId={+user.id} />
            {demandDetailsList && demandDetailsList.length > 1 && (
              <div style={{ display: 'flex', borderBottom: '1px solid #e5e7eb', marginBottom: '1rem', backgroundColor: '#f9fafb', borderRadius: '0.375rem 0.375rem 0 0' }}>
                <button
                  type="button"
                  style={{
                    padding: '0.5rem 1rem',
                    fontWeight: 'bold',
                    border: 'none',
                    borderBottom: activeDocTab === "signed" ? '2px solid #0056b3' : '2px solid transparent',
                    color: activeDocTab === "signed" ? '#0056b3' : '#6b7280',
                    backgroundColor: 'transparent',
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    setActiveDocTab("signed");
                    const doc = demandDetailsList.find(d => d.doc_type === "demand note" || d.doc_type === "demand_note") || demandDetailsList[0];
                    setDemandDetails(doc);
                  }}
                >
                  <i className="fa fa-pencil-square-o mr-2"></i> L3 Signed Demand Note
                </button>
                <button
                  type="button"
                  style={{
                    padding: '0.5rem 1rem',
                    fontWeight: 'bold',
                    border: 'none',
                    borderBottom: activeDocTab === "revised" ? '2px solid #0056b3' : '2px solid transparent',
                    color: activeDocTab === "revised" ? '#0056b3' : '#6b7280',
                    backgroundColor: 'transparent',
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    setActiveDocTab("revised");
                    const doc = demandDetailsList.find(d => d.doc_type === "revised demand note" || d.doc_type === "revised_demand_note" || d.doc_type === "revised") || demandDetailsList[1] || demandDetailsList[0];
                    setDemandDetails(doc);
                  }}
                >
                  <i className="fa fa-calculator mr-2"></i> Revised calculations statement
                </button>
              </div>
            )}
            <iframe
              title="PDF Viewer"
              src={`${demandDetails?.file_url || ""}#toolbar=0`}
              className={`${style.orgPdf} transparentBorder`}
              frameBorder="0"
            ></iframe>
            <div className={`${style.buttonSection} mt-7`}>
              {demandDetailsList && demandDetailsList.length > 1 && activeDocTab === "signed" ? (
                <button
                  type="button"
                  className="bg-primary ml-4 px-6 py-2 font-bold text-white rounded-full"
                  onClick={() => {
                    setActiveDocTab("revised");
                    const doc = demandDetailsList.find(d => d.doc_type === "revised demand note" || d.doc_type === "revised_demand_note" || d.doc_type === "revised") || demandDetailsList[1] || demandDetailsList[0];
                    setDemandDetails(doc);
                  }}
                >
                  Next: Review Revised Late Fee <i className="fa fa-arrow-right ml-2"></i>
                </button>
              ) : (
                <>
                  <button
                    className="bg-primary ml-4 px-6 py-2 font-bold text-white rounded-full disabled:bg-gray-300"
                    onClick={() => setLgShow(true)}
                  >
                    Pay Offline
                  </button>
                  {showPayNowButton && <PayOnline applicationId={+user?.id} />}
                  <button
                    className="bg-primary ml-4 px-6 py-2 font-bold text-white rounded-full disabled:bg-gray-300"
                    onClick={() => setPaymentLgShow(true)}
                  >
                    Upload Receipt
                  </button>
                  <button
                    className="bg-primary ml-4 px-6 py-2 font-bold text-white rounded-full disabled:bg-gray-300"
                    onClick={handleDownloadPDF}
                  >
                    Download
                  </button>
                </>
              )}
            </div>
          </div>
          <>
            <Modal
              aria-labelledby="example-custom-modal-styling-title"
              size="xl"
              centered
              dialogClassName="modal-100w"
              show={PaymentLgShow}
              onHide={() => setPaymentLgShow(false)}
            >
              <div className={style.modalPd}>
                <Modal.Header
                  closeButton
                  style={{
                    backgroundImage: "revert !important",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <h5 className={style.popUpHeading}>Upload Receipt</h5>
                  </div>
                </Modal.Header>
                <Modal.Body className="grid-example">
                  <Container>
                    <Row>
                      <Col xs={20} md={5} className={style.modalColumn}>
                        <div className={style.timelineTitle}>
                          Payment Timeline
                        </div>
                        {/* timeline beguns */}
                        <MDBContainer fluid className="py-5 gradient-custom-2">
                          {receipts.length === 0 ? (
                            <div className="text-center mt-10">No records to display</div>
                          ) : (
                            receipts.map((receipt, index) => (
                              <div className={style.mainTimeline} key={index}>
                                <div
                                  key={index}
                                  onClick={() => handleReceiptClick(receipt, index)}
                                  className={`${style.timelineBox} ${style.rightSideBox}`}
                                >
                                  {receipt.payment_status === 'Draft' ||
                                    receipt.payment_status === 'Submitted' ||
                                    receipt.payment_status === 'Payment Acknowledgment' ? (
                                    <MDBCard
                                      style={{
                                        backgroundColor: "#e9b925",
                                        position: "relative",
                                      }}
                                      className={style.mCardTimeline}
                                    >
                                      <div className={style.notch} style={{ borderRight: '10px solid #e9b925' }}></div> {/* Add triangular notch */}
                                      <MDBCardBody>
                                        <h5 className={style.whiteTxt}>{receipt.amount_paid} INR</h5>
                                        <p className="mt-2 mb-0">
                                          <div className={style.timelineMessage}>
                                            <div>{receipt.payment_date}</div>
                                            <div>Status: {receipt.payment_status}</div>
                                          </div>
                                        </p>
                                      </MDBCardBody>
                                    </MDBCard>
                                  ) : receipt.payment_status === 'Payment Discrepancy' ? (
                                    <MDBCard
                                      style={{
                                        backgroundColor: "#FF0E0E",
                                        position: "relative",
                                      }}
                                      className={style.mCardTimeline}
                                    >
                                      <div className={style.notch} style={{ borderRight: '10px solid #FF0E0E' }}></div>
                                      <MDBCardBody>
                                        <h5 className={style.whiteTxt}>{receipt.amount_paid} INR</h5>
                                        <p className="mt-2 mb-0">
                                          <div className={style.timelineMessage}>
                                            <div>{receipt.payment_date}</div>
                                            <div>Status: {receipt.payment_status}</div>
                                          </div>
                                        </p>
                                      </MDBCardBody>
                                    </MDBCard>
                                  ) : (
                                    <MDBCard
                                      style={{
                                        backgroundColor: "#25B101",
                                        position: "relative",
                                      }}
                                      className={style.mCardTimeline}
                                    >
                                      <div className={style.notch} style={{ borderRight: '10px solid #25B101' }}></div>
                                      <MDBCardBody>
                                        <h5 className={style.whiteTxt}>{receipt.amount_paid} INR</h5>
                                        <p className="mt-2 mb-0">
                                          <div className={style.timelineMessage}>
                                            <div className={style.receiptDate}>{receipt.payment_date}</div>
                                            <div>Status: <span className={style.statusText}>{receipt.payment_status}</span> </div>
                                          </div>
                                        </p>
                                      </MDBCardBody>
                                    </MDBCard>
                                  )}
                                </div>
                              </div>
                            ))
                          )}
                        </MDBContainer>
                      </Col>
                      <Col xs={20} md={7} className={style.modalColumn}>
                        <div className={style.inputInfoBox}>
                          <div className={style.statusDetails}>
                            {baseAmount !== null && interestAccumulated !== null && interestAccumulated > 0 && (
                              <>
                                <div className={style.detailItem}>
                                  <div className={style.left}>
                                    <strong className={style.titleMid}>
                                      Base regularization fee:
                                    </strong>
                                  </div>
                                  <div className={style.center}>:</div>
                                  <div className={style.right}>
                                    <span>{baseAmount}</span> INR
                                  </div>
                                </div>
                                <div className={style.detailItem} style={{ color: '#d97706' }}>
                                  <div className={style.left}>
                                    <strong className={style.titleMid}>
                                      Late interest penalty:
                                    </strong>
                                    {daysPending > 60 && (
                                      <span style={{ fontSize: '0.75rem', display: 'block', color: '#6b7280' }}>
                                        ({daysPending} days late)
                                      </span>
                                    )}
                                  </div>
                                  <div className={style.center}>:</div>
                                  <div className={style.right}>
                                    <span>{interestAccumulated}</span> INR
                                  </div>
                                </div>
                              </>
                            )}
                            <div className={style.detailItem}>
                              <div className={style.left}>
                                <strong className={style.titleMid}>
                                  Total amount:
                                </strong>
                              </div>
                              <div className={style.center}>:</div>
                              <div className={style.right}>
                                {totalAmount && (
                                  <span>{totalAmount ?? "-"}</span>
                                )} INR
                              </div>
                            </div>
                            <div className={style.detailItem}>
                              <div className={style.left}>
                                <strong className={style.titleMid}>
                                  Payment Acknowledgment
                                </strong>
                              </div>
                              <div className={style.center}>: </div>
                              <div className={style.right}>{totalAmountPaid ?? "-"} INR</div>
                            </div>
                          </div>
                          <hr />
                          <div className={style.spacingBtw}></div>
                          {receipts.map((receipt, index) => (
                            <div
                              key={index}
                              className={`${style.uploadsection} ${style.receiptDetails}`}
                            >
                              {selectedReceipt === receipt && (
                                <div className="appIdForm">
                                  <div className={style.formRow}>
                                    <div className={style.formGroup}>
                                      <label className={style.subHeadingLabel}>
                                        Receipt Number
                                      </label>
                                      {receipt.payment_status === 'Payment Acknowledgment' ? (
                                        <input
                                          className={style.InputTxtNum}
                                          type="text"
                                          value={receipt.receipt_no}
                                          style={{ border: '3px solid #FF0000' }}
                                          disabled
                                        />
                                      ) : (
                                        <input
                                          className={style.InputTxtNum}
                                          type="text"
                                          value={receipt.receipt_no}
                                          style={{ border: '3px solid #FF0000' }}
                                          onChange={(e) => handleReceiptChange(e, index, 'receipt_no')}
                                        />
                                      )}


                                    </div>
                                    <div className={style.formGroup}>
                                      <label className={style.subHeadingLabel}>
                                        Amount Paid
                                      </label>
                                      <div className={style.amountPaidContainer}>
                                        {receipt.payment_status === 'Payment Acknowledgment' ? (
                                          <input
                                            className={style.InputTxtNum}
                                            type="number"
                                            value={receipt.amount_paid}
                                            style={{ border: '3px solid #FF0000' }}
                                            disabled
                                          />
                                        ) : (
                                          <input
                                            className={style.InputTxtNum}
                                            type="number"
                                            value={receipt.amount_paid}
                                            style={{ border: '3px solid #FF0000' }}
                                            onChange={(e) =>
                                              handleReceiptChange(
                                                e,
                                                index,
                                                'amount_paid'
                                              )
                                            }
                                          />
                                        )}

                                      </div>
                                    </div>
                                  </div>
                                  <div className={style.formRow}>
                                    <div className={style.formGroup}>
                                      <label className={style.subHeadingLabel}>
                                        Payment Date
                                      </label>
                                      {receipt.payment_status === 'Payment Acknowledgment' ? (
                                        <input
                                          className={style.InputTxtNum}
                                          type="date"
                                          value={receipt.payment_date}
                                          style={{ border: '3px solid #FF0000' }}
                                          disabled
                                        />
                                      ) : (
                                        <input
                                          className={style.InputTxtNum}
                                          type="date"
                                          value={receipt.payment_date}
                                          style={{ border: '3px solid #FF0000' }}
                                          onChange={(e) =>
                                            handleReceiptChange(
                                              e,
                                              index,
                                              'payment_date'
                                            )
                                          }
                                        />
                                      )}
                                    </div>
                                    <div className={style.formGroup}>
                                      <label className={style.subHeadingLabel}>
                                        Receipt File
                                      </label>
                                      {receipt.payment_status === 'Payment Acknowledgment' ? (
                                        <div className={style.redDiv}>
                                          <input
                                            type="file"
                                            style={{ display: 'none' }}
                                            disabled
                                            ref={inputRef}
                                          />
                                          <button disabled className={style.greyBtn}>
                                            Choose file
                                          </button>
                                          <input
                                            type="text"
                                            value={receipt.receipt_file}
                                            readOnly
                                            onMouseEnter={handleHoverIn}
                                          />
                                        </div>
                                      ) : (
                                        <div className={style.redDiv}>
                                          <input
                                            type="file"
                                            style={{ display: 'none' }}
                                            onChange={(e) => handleReceiptChange(e, index, 'receipt_file')}
                                            ref={inputRef}
                                          />
                                          <button onClick={() => inputRef.current?.click()} className={style.greyBtn}>
                                            Choose file
                                          </button>
                                          <input
                                            type="text"
                                            value={receipt.receipt_file}
                                            readOnly
                                            onMouseEnter={handleHoverIn}
                                          />
                                        </div>
                                      )}


                                    </div>

                                    {/* <button
                                      className={style.trashButton}
                                      onClick={() => {
                                        setSelectedReceipt(null); setIsReceiptEdit(false);
                                        setCurrentEditRecipt(-1);
                                      }}
                                    >
                                      <img
                                        src={dustbin}
                                        alt=""
                                        className={style.trashIcon}
                                      />
                                    </button> */}
                                    <div className={style.redDeleteBtn}>
                                      <DeleteButton
                                        onClick={() => {
                                          setSelectedReceipt(null); setIsReceiptEdit(false);
                                          setCurrentEditRecipt(-1);
                                        }}
                                      // className={style.trashButton}
                                      />
                                    </div>


                                  </div>
                                  {isHovered && (
                                    <>
                                      <div  >
                                        <Modal show={isHovered} onHide={() => setIsHovered(false)}
                                          size="lg"
                                          aria-labelledby="example-modal-sizes-title-lg"
                                          className={style.pdfReceiptModal}
                                        >
                                          <Modal.Header closeButton >
                                            <Modal.Title id="example-modal-sizes-title-lg">
                                            </Modal.Title>
                                          </Modal.Header>
                                          <Modal.Body> {isHovered && (
                                            <div>
                                              <iframe
                                                src={receipt.receipt_file}
                                                title="Receipt PDF"
                                                className={style.hoverIframe}
                                                style={{ width: '100%', height: '500px' }} // Adjust dimensions as needed
                                              ></iframe>
                                            </div>
                                          )}</Modal.Body>
                                        </Modal>
                                      </div>
                                    </>
                                  )}
                                </div>
                              )}
                            </div>
                          ))}
                          {/* Dynamically render receipt sections based on count */}
                          {[...Array(receiptSections)].map((_, index) => (
                            <div className={style.uploadsection} key={index}>
                              <div className="appIdForm">
                                <div className={style.formRow}>
                                  <div className={style.formGroup}>
                                    <label className={style.subHeadingLabel}>
                                      Receipt Number <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      className={style.InputTxtNum}
                                      ref={inputRef}
                                      type="text"
                                      placeholder="Enter Receipt Number"
                                      value={receiptNo[index] || ''}
                                      onChange={(e) =>
                                        setReceiptName((prev) => {
                                          const newState = [...prev];
                                          newState[index] = e.target.value;
                                          return newState;
                                        })
                                      }
                                    />
                                  </div>
                                  <div className={style.formGroup}>
                                    <label className={style.subHeadingLabel}>
                                      Amount Paid <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      ref={inputRef}
                                      className={style.InputTxtNum}
                                      type="number"
                                      step="0.01"
                                      placeholder="Enter Amount Paid"
                                      value={amountPaid[index] || ''}
                                      onChange={(e) =>
                                        setAmountPaid((prev) => {
                                          const newState = [...prev];
                                          newState[index] = parseFloat(e.target.value);
                                          return newState;
                                        })
                                      }
                                      maxLength={100}
                                    />
                                  </div>
                                </div>
                                <div className={style.LastRowFlex}>
                                  <div className={style.formRow}>
                                    <div className={style.formGroup}>
                                      <label className={style.subHeadingLabel}>
                                        Payment Date <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        ref={inputRef}
                                        className={style.InputTxtNum}
                                        type="date"
                                        value={paymentDate[index] || ''}
                                        onChange={(e) =>
                                          setPaymentDate((prev) => {
                                            const newState = [...prev];
                                            newState[index] = e.target.value;
                                            return newState;
                                          })
                                        }
                                        placeholder="Enter Payment Date"
                                      />
                                    </div>
                                    <div className={style.formGroup}>
                                      <label className={style.subHeadingLabel}>
                                        Upload Receipt <span className="text-danger">*</span>
                                      </label>

                                      <div className={style.fileInputContainer}>
                                        <input
                                          ref={inputRef}
                                          className={style.InputFileUpload}
                                          type="file"
                                          value=""
                                          onChange={(e) => {
                                            if (e.target.files && e.target.files.length > 0) {
                                              const file = e.target.files[0];
                                              setReceiptFile((prev) => {
                                                const newState = [...prev];
                                                newState[index] = file;
                                                return newState;
                                              });
                                            }
                                          }}
                                          placeholder="receipt file"
                                        />
                                        {receiptFile[index]?.name && (
                                          <span className={style.fileName}>{receiptFile[index].name}</span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className={style.addRemoveBtn}>
                                    {index === 0 ? (
                                      <button onClick={handleAddSection} className={style.addButton}>
                                        <img src={plusIcon} alt="" className={style.plusIcon} />
                                      </button>
                                    ) : (
                                      // <button onClick={() => handleRemoveSection(index)} className={style.trashButton}>
                                      //   <img src={dustbin} alt="" className={style.trashIcon} />
                                      // </button>
                                      <div className={style.deleteBtn}>
                                        <DeleteButton
                                          onClick={() => handleRemoveSection(index)}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>

                              </div>
                            </div>
                          ))}                        </div>
                      </Col>
                    </Row>
                    {showButton && (
                      <div>
                        <div className={style.buttonSectionModule}>
                          {receipts.length === 0 ? (
                            <button
                              className={style.publishButton}
                              disabled
                              style={{
                                backgroundColor: '#cccccc',
                                cursor: 'not-allowed',
                              }}
                            >
                              Submit
                            </button>
                          ) : (
                            <button
                              className={style.publishButton}
                              onClick={() => {
                                handlePublish(true);
                                navigate('/payment-list');
                                setTimeout(() => {
                                  window.location.reload();
                                }, 2000);
                              }}
                            >
                              Submit
                            </button>
                          )}
                          {/* <button
                            className={style.editButton}
                            onClick={handleEditReceipt}
                          >
                            Edit
                          </button> */}

                          <button ref={saveButtonRef} className={style.saveButton} onClick={() => {
                            handleSave();

                            // setPaymentLgShow(false);

                          }}>
                            {isSaving ? "Saving..." : "Save"}
                          </button>

                        </div>
                      </div>
                    )}

                  </Container>
                </Modal.Body>
              </div>
            </Modal>
          </>
          {/* Upload Recept module */}
          <>
            <Modal
              size="lg"
              show={lgShow}
              onHide={() => setLgShow(false)}
              aria-labelledby="example-modal-sizes-title-vcenter-lg"
              centered
            >
              <div className={style.modalPd}>
                <Modal.Header
                  closeButton
                  style={{
                    backgroundImage: "revert-layer !important",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <h5 className={style.popUpHeading}>Account Details</h5>
                  </div>
                </Modal.Header>

                <Modal.Body>
                  <div className={style.appIdForm}>
                    <div className={style.formRow}>

                      <div className={style.formGroup}>
                        <label className={style.subHeadingLabel}>
                          Account Holder Name

                        </label>
                        <input
                          className={style.InputTxtNum}
                          type="text"
                          name="account_no"
                          value={bankDetails.account_holder_name}
                          // value={accountNo}
                          readOnly={true}
                        />
                      </div>

                      <div className={style.formGroup}>
                        <label className={style.subHeadingLabel}>
                          Account Number
                        </label>
                        <input
                          className={style.InputTxtNum}
                          type="text"
                          name="account_no"
                          value={bankDetails.account_no}
                          // value={accountNo}
                          readOnly={true}
                        />
                      </div>


                    </div>
                    <div className={style.formRow}>
                      <div className={style.formGroup}>
                        <label className={style.subHeadingLabel}>
                          IFSC

                        </label>
                        <input
                          className={style.InputTxtNum}
                          type="text"
                          name="ifs_code"
                          value={bankDetails.ifs_code}
                          // maxLength={10}
                          // value={ifsCode}
                          readOnly={true}
                        />
                      </div>
                      <div className={style.formGroup}>
                        <label className={style.subHeadingLabel}>
                          Account Type
                        </label>
                        <select
                          name="account_type"
                          className={style.InputTxtNum}
                          value={bankDetails.account_type}
                          disabled
                        >
                          <option value="" disabled>
                            Select Account Type
                          </option>
                          <option value="Savings Account">
                            Savings Account
                          </option>
                          <option value="Current Account">
                            Current Account
                          </option>
                        </select>

                      </div>

                    </div>
                    <div className={style.formRow}>

                      <div className={style.formGroup}>
                        <label className={style.subHeadingLabel}>
                          Branch Name
                        </label>
                        <input
                          className={style.InputTxtNum}
                          type="text"
                          name="branch_name"
                          value={bankDetails.branch_name}
                          // value={bank}
                          readOnly={true}
                        />
                      </div>
                      <div className={style.formGroup}>
                        <label className={style.subHeadingLabel}>
                          Bank Name
                        </label>
                        <input
                          className={style.InputTxtNum}
                          type="text"
                          name="bank_name"
                          value={bankDetails.bank_name}
                          // value={bank}
                          readOnly={true}
                        />
                      </div>
                    </div>
                    <div>
                      Note : Please make a payment using the bank information provided on the offline payment page. After payment, visit the Municipal Council office after three days. Take receipt of payment from the Municipal Council office and upload.
                    </div>
                  </div>
                </Modal.Body>
              </div>
            </Modal>
          </>
        </div>
      </div>
    </div>
  );
}

export default payNow;
function setError(message: string) {
  throw new Error("Function not implemented.");
}

